<div
  class="feature-card d-flex flex-wrap align-items-center"
  [ngClass]="{ 'flex-row-reverse': reverse }"
>
  <!-- Image Section -->
  <div class="feature-card__image-section">
    <img [src]="image" class="img-fluid" alt="Feature Image" />
  </div>

  <!-- Content Section -->
  <div class="feature-card__content-section">
    <h2 class="feature-card__title headingBL">{{ title }}</h2>

    <ng-container *ngIf="!isList">
      <p class="feature-card__description">{{ description }}</p>
    </ng-container>

    <ng-container *ngIf="isList">
      <ul>
        <li *ngFor="let item of descriptionList">{{ item }}</li>
      </ul>
    </ng-container>
  </div>
</div>
